import React from "react";
import PropTypes from "prop-types";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";

import "./page-header.scss";

function PageHeaderNavigation({
  title,
  onClickBack,
  buttons,
  toggleSwitch: ToggleSwitch,
}) {
  return (
    <div className="page-header-with-title">
      <div className="page-header_title-and-switch">
        <div>{title}</div>
        {ToggleSwitch}
        {onClickBack && (
          <ArrowBackIcon
            className="page-header_back-button"
            onClick={onClickBack}
          />
        )}
      </div>
      {buttons && <div className="page-header_buttons">{buttons}</div>}
    </div>
  );
}

PageHeaderNavigation.defaultProps = {
  title: "",
  onClickBack: null,
  buttons: [],
  toggleSwitch: null,
};

PageHeaderNavigation.propTypes = {
  // From parent
  title: PropTypes.string, // The title of the page
  onClickBack: PropTypes.func, // The function to call when the back button is clicked
  toggleSwitch: PropTypes.elementType, // The switch to display
  buttons: PropTypes.node, // The buttons to display on the right side of the header
};
export default PageHeaderNavigation;
